/**
 * @file コンポーネント：執刀医リスト ロジック管理
 */

// ライブラリ読み込み
import React from "react";

// Presenter読み込み
import { Presenter } from "./presenter";

// コンポーネントを返す
export const Surgeonlist = (props) => {
    // Presenterに渡す
    return <Presenter {...props} />;
};
